// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { WarrantyResult } from "@store/Framework/Types/ApiModels";

const warrantyServiceUri = "/api/v1/warranty/";

export async function getWarrantyBySerial(serialNumber: string) {
    const warrantyBySerial = await get<WarrantyResult>(`${warrantyServiceUri}${serialNumber}`);
    return warrantyBySerial;
}

export async function getWarrantyBySerialAndModel(serialNumber: string, modelNumber: string) {
    const warrantyBySerialAndModel = await get<WarrantyResult>(`${warrantyServiceUri}${serialNumber}/${modelNumber}`);
    return warrantyBySerialAndModel;
}
